export class SearchCnaeCreditRiskModel {
  public cnaeNumber: string;
  public serviceContract: number;
}
